<div
    id="hs-navbar-example"
    class="hidden hs-collapse lg:block absolute lg:relative overflow-hidden lg:overflow-visible transition-all lg:transition-transform duration-300 basis-full grow"
    aria-labelledby="hs-navbar-example-collapse"
>
    <div
        class="flex lg:flex-row flex-col lg:justify-end lg:items-center bg-white lg:bg-transparent mt-5 lg:mt-0 p-2 lg:p-0 border border-gray-800 lg:border-none rounded-lg w-fit ~gap-4/12"
    >
        @for (item of navbarItems(); track $index; let i = $index) {
            @if (!item.subLinkItems.length) {
                <a
                    [routerLink]="
                        navbarService.getNavbarLink(item.linkItem, page())
                    "
                    [fragment]="
                        navbarService.getFragmentFromLinkItem(item.linkItem)
                    "
                    [ngClass]="{
                        'text-primary': navbarService.isActiveLink(
                            item.linkItem
                        ),
                        'text-black': domHandler.isMobile,
                    }"
                    (click)="navbarService.handleNavbarLinkClick(item.linkItem)"
                    class="hover:text-primary whitespace-nowrap hover:scale-105 transition-transform ~text-xl/2xl"
                    aria-current="page"
                    >{{ item.linkItem.text }}</a
                >
            } @else {
                <div
                    class="[--strategy:static] sm:[--strategy:fixed] hs-dropdown [--adaptive:none]"
                >
                    <button
                        id="hs-navbar-example-dropdown-{{ i }}"
                        type="button"
                        class="hover:text-primary hover:scale-105 transition-transform hs-dropdown-toggle"
                        [ngClass]="{
                            'text-primary': navbarService.isActiveLink(
                                item.linkItem
                            ),
                            'text-black': domHandler.isMobile,
                        }"
                        (click)="
                            navbarService.handleNavbarLinkClick(item.linkItem)
                        "
                        aria-haspopup="menu"
                        aria-expanded="false"
                        aria-label="Mega Menu"
                    >
                        <div class="flex items-center ~text-xl/2xl">
                            {{ item.linkItem.text }}
                            <svg
                                class="ms-2 size-4 lg:hs-dropdown-open:rotate-0 hs-dropdown-open:-rotate-180 transition-transform duration-300 shrink-0 chevron-down"
                                [ngClass]="{
                                    'bg-primary rounded-full':
                                        navbarService.isActiveSubLink(item),
                                    'stroke-white':
                                        (slugService.isHome() &&
                                            domHandler.isDesktop) ||
                                        page() === 'apartment',
                                    'stroke-black':
                                        !slugService.isHome() ||
                                        domHandler.isMobile,
                                }"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </div>
                    </button>

                    <div
                        class="hidden top-full before:-top-5 z-10 before:absolute space-y-2 bg-white opacity-0 hs-dropdown-open:opacity-100 sm:shadow-md p-1 sm:border border-gray-200 rounded-lg sm:w-48 before:w-full before:h-5 transition-[opacity,margin] duration-[150ms] ease-in-out hs-dropdown-menu before:start-0"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="hs-navbar-example-dropdown"
                    >
                        @for (subItem of item.subLinkItems; track $index) {
                            <a
                                class="flex items-center gap-x-3.5 hover:bg-white focus:bg-neutral-500 px-2 rounded focus:outline-none text-black hover:text-primary focus:text-primary text-lg hover:scale-105 transition-transform hs-dropdown-close"
                                [ngClass]="{
                                    ' bg-primary':
                                        navbarService.isActiveLink(subItem),
                                }"
                                (click)="
                                    navbarService.handleNavbarLinkClick(subItem)
                                "
                                [fragment]="
                                    navbarService.getFragmentFromLinkItem(
                                        subItem
                                    )
                                "
                                [routerLink]="
                                    navbarService.getNavbarLink(subItem, page())
                                "
                            >
                                {{ subItem.text }}
                            </a>
                        }
                    </div>
                </div>
            }
        }
        <div
            class="lg:hidden flex justify-center justify-self-end items-center gap-4"
        >
            @if (page() === "hof") {
                <a
                    [routerLink]="[
                        '/',
                        languageService.getLanguageCode,
                        'hof',
                        'kontakt',
                    ]"
                >
                    <button
                        class="bg-white hover:bg-gray-200 shadow-[0_0_2px_2px_rgba(0,0,0,.1)] py-2 border border-gray-200 rounded-full font-medium text-primary text-base hover:scale-105 transition-[colors,transform] ~px-5/6"
                    >
                        {{ "contactYard.contact" | translate }}
                    </button>
                </a>
            } @else {
                <app-language-selection
                    [isMinimal]="true"
                ></app-language-selection>
            }
            <app-social-media-links
                class="flex fill-black"
            ></app-social-media-links>
        </div>
    </div>
</div>
